// extracted by mini-css-extract-plugin
export default {"dialog-field":"Portfolio_dialog-field__qdpmn"};